import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-root',
  imports: [],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  constructor(private translate: TranslateService) {
    this.translate.addLangs(['hu', 'en']);
    const htmlLang = document.documentElement.lang || 'hu';
    this.translate.use(htmlLang).toPromise();
  }
  title = 'foxpost';
}
